// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"241":"257565ba","358":"4347b026","982":"15c0987b"}[chunkId] + ".chunk.css";
};